import type { IChatStreamEvent } from '@/composables/useEventStream'

/**
 * Keys on the SSE `message_complete` envelope that are not copied onto the in-memory
 * `IChatMessage` (everything else on the event is merged in; `content` is handled separately).
 */
const MESSAGE_COMPLETE_ENVELOPE_KEYS = new Set<string>([
  'chat_id',
  'message',
  'message_id',
  'background_job_type',
  'job_id',
  'content_replace',
  'content',
])

export function buildAssistantPatchFromMessageCompleteEvent(
  event: IChatStreamEvent,
): Record<string, unknown> {
  const patch: Record<string, unknown> = {}
  if (event.message) {
    for (const key of Object.keys(event.message)) {
      if (key === 'content') continue
      const fieldValue = (event.message as Record<string, unknown>)[key]
      if (fieldValue !== undefined) patch[key] = fieldValue
    }
  }
  for (const key of Object.keys(event)) {
    if (MESSAGE_COMPLETE_ENVELOPE_KEYS.has(key)) continue
    const fieldValue = (event as Record<string, unknown>)[key]
    if (fieldValue !== undefined) patch[key] = fieldValue
  }
  const messageId = event.message?.id ?? event.message_id
  if (messageId !== undefined) patch.id = messageId
  return patch
}
